import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-sales-deck',
  templateUrl: './nav-sales-deck.component.html',
  styleUrls: ['./nav-sales-deck.component.scss']
})
export class NavSalesDeckComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
